export default [
    { id: 1, value: 'Under 1'},
    { id: 2, value: '1 to 5'},
    { id: 3, value: '6 to 19'},
    { id: 4, value: '21 to 65'},
    { id: 5, value: 'Over 65'},
];